import { Immutable } from "immer";
import React from "react";
import { t } from "ttag";

import { IProduct } from "../../../models/catalogue";
import { ISafeHTML, isoSafeHTML } from "../../../models/nominals";
import { ICompareTile } from "../../../models/product-compare";
import { useViewport } from "../../../store/common/hooks";
import { useAppSelector } from "../../../store/reducers";
// eslint-disable-next-line import/no-restricted-paths -- pre-existing cross-app dependency (Phase E exemption)
import { ProductCompareGrid__ColumnCard_Component } from "../../product-compare/ProductCompareGrid__ColumnCard/ProductCompareGrid__ColumnCardContent";
import { IModularConfiguratorOptionSet } from "../models";

import styles from "./index.module.scss";

type IProps = Immutable<{
    optionSet: IModularConfiguratorOptionSet;
}>;

const getTiles = (
    optionSet: IModularConfiguratorOptionSet,
    rootProducts: readonly IProduct[],
): ICompareTile[] => {
    if (!optionSet.root_product_compare_modal) {
        return [];
    }
    const baseTiles = optionSet.root_product_compare_modal.products;
    // Annotate each tile with the related product data
    const tiles = baseTiles
        .map((baseTile): ICompareTile => {
            const rootProduct = rootProducts.find((rp) => {
                return rp.id === baseTile.product_compare_tile.product_id;
            });
            return {
                ...baseTile,
                rootProducts: rootProduct ? [rootProduct] : [],
            };
        })
        .filter((tile) => tile.rootProducts.length > 0);
    return tiles;
};

const buildHeader = (): ISafeHTML => {
    return isoSafeHTML.wrap(
        `<h3 id="heading">${t`What's the Difference?`}</h3>`,
    );
};

export const RootProductCompareModalContent = (
    props: IProps,
): React.ReactNode => {
    const viewport = useViewport();
    const priceSelectValue: string = useAppSelector(
        (state) => state.productcompare.priceSelectValue,
    );
    const rootProducts: readonly IProduct[] = useAppSelector(
        (state) => state.configurator.entities.rootProducts,
    );

    const tiles = getTiles(props.optionSet, rootProducts);

    return (
        <div className={styles.root}>
            {/* wrapping with the same class as the Wagtail Block Variant to ensure proper styling */}
            <div className={`${styles.grid} product-compare-grid-column-card`}>
                <ProductCompareGrid__ColumnCard_Component
                    header={buildHeader()}
                    tiles={tiles}
                    priceSelectValue={priceSelectValue}
                    viewport={viewport}
                />
            </div>
        </div>
    );
};
